import { palette } from "../palette";
export const buttonIcon = {
  primary: {
    color: palette.gray.primary,
    backgroundColor: palette.white,
    borderWidth: 0,
    boxShadow: "0 1px 4px 0 rgba(0,0,0,0.48)",
    padding: "9px",
    minWidth: "40px",
    hover: {
      color: palette.black,
      backgroundColor: palette.white,
      borderWidth: 0,
      boxShadow: "0 8px 8px 0 rgba(0,0,0,0.24), 0 0 8px 0 rgba(0,0,0,0.32)",
      padding: "9px"
    },
    disabled: {
      padding: "9px"
    }
  },
  secondary: {
    color: palette.gray.primary,
    backgroundColor: palette.white,
    borderColor: palette.gray.primary,
    borderWidth: "1px",
    padding: "8px",
    minWidth: "40px",
    hover: {
      color: palette.black,
      backgroundColor: palette.white,
      borderWidth: 0,
      padding: "9px"
    },
    disabled: {
      padding: "9px"
    }
  },
  tertiary: {
    color: palette.black,
    backgroundColor: palette.white,
    borderWidth: "1px",
    padding: "8px",
    minWidth: "40px",
    hover: {
      color: palette.action.primary,
      backgroundColor: palette.gray.hover,
      borderWidth: "1px",
      boxShadow: "none",
      padding: "8px"
    },
    active: {
      color: palette.white,
      backgroundColor: palette.action.primary,
      borderWidth: 0,
      boxShadow: "none",
      padding: "9px"
    },
    disabled: {
      borderColor: palette.gray.lighter,
      borderWidth: "1px",
      boxShadow: "none",
      padding: "8px"
    }
  }
};